<template>
  <div class="container">
    <div style="margin: 0 10px">
      <div class="title-wrapper">
        <!-- <div>
          <span class="title">新品总览</span>
          <span class="label">基于产品层级数据</span>
        </div> -->
        <div>
          <span class="title" style="margin-right: 20px">新品总览</span>
          <span
            class="tab-item"
            :class="{ active: tab0active === 1 }"
            @click="tab0Click(1)"
            >产品</span
          >
          <span
            class="tab-item"
            :class="{ active: tab0active === 2 }"
            @click="tab0Click(2)"
            >SPU</span
          >
          <router-link to="/newProduct/newproduct-process">
            <el-link
              style="
                position: relative;
                top: -2px;
                left: 15px;
                font-weight: normal;
              "
              type="warning"
              :underline="false"
              >查看新品进度更新详情 ></el-link
            >
          </router-link>
        </div>
        <div>
          <el-radio-group
            v-model="spuDateType"
            @change="handleRadioChange"
            v-if="tab0active === 2"
          >
            <el-radio label="1">预计上线时间</el-radio>
            <el-radio label="2">实际上线时间</el-radio>
          </el-radio-group>
          <span class="text"
            >{{ tab0active == 1 ? "实际上市时间" : "时间" }}&nbsp;</span
          >
          <el-date-picker
            class="date-picker"
            v-model="startTime"
            type="date"
            size="mini"
            style="width: 140px"
            value-format="yyyy-MM-dd"
            placeholder="起"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <el-date-picker
            v-model="endTime"
            type="date"
            size="mini"
            style="width: 140px"
            value-format="yyyy-MM-dd"
            placeholder="止"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            class="buttonStyle"
            @click="seach"
            >搜索</el-button
          >
        </div>
      </div>
      <div
        class="cavans"
        ref="chart1"
        v-loading="loading1"
        element-loading-background="rgba(255,255,255,0.3)"
      ></div>
    </div>

    <el-row>
      <el-col :span="16">
        <div style="margin: 0 10px; position: relative">
          <div class="title-wrapper">
            <div>
              <span class="title" style="margin-right: 20px">进度总览</span>
              <span
                class="tab-item"
                :class="{ active: tab1active === 1 }"
                @click="tab1Click(1)"
                >SKU</span
              >
              <span
                class="tab-item"
                :class="{ active: tab1active === 2 }"
                @click="tab1Click(2)"
                >产品</span
              >
              <span
                class="tab-item"
                :class="{ active: tab1active === 3 }"
                @click="tab1Click(3)"
                >SPU</span
              >
            </div>
          </div>
          <div class="cavans" ref="chart2" v-if="tab1active === 1"></div>
          <div v-if="tab1active === 2">
            <div class="category-select">
              <span class="lableFont">品类&nbsp;</span>
              <el-select
                v-model="category"
                size="mini"
                style="width: 140px"
                multiple
                collapse-tags
                @change="handleCategoryChange"
              >
                <el-option
                  v-for="(item, index) in categorys"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
            <div
              class="cavans"
              ref="chart3"
              v-loading="loading2"
              element-loading-background="rgba(255,255,255,0.3)"
            ></div>
          </div>
          <div
            class="cavans"
            ref="chart6"
            v-loading="loading4"
            element-loading-background="rgba(255,255,255,0.3)"
            v-if="tab1active === 3"
          ></div>
        </div>
      </el-col>
      <el-col :span="8">
        <div style="margin-right: 10px; position: relative">
          <div class="title-wrapper">
            <div>
              <span class="title" style="margin-right: 20px"
                >已上架SPU数量</span
              >
            </div>
          </div>
          <div class="cavans" ref="chart5"></div>
        </div>
      </el-col>
    </el-row>

    <div style="margin: 10px 10px 0">
      <el-row :gutter="10">
        <el-col :span="6" v-for="(item, index) in overviewData" :key="index">
          <div class="grid-item">
            <div class="haeaderColor">
              <div
                v-for="item in colorList"
                :key="item"
                :style="`background: ${item};flex: 1`"
              ></div>
            </div>
            <div class="content-time">
              <div class="img">
                <img
                  :src="
                    require('../../../assets/images/lifeCycle_img/' +
                      'time' +
                      index +
                      '.png')
                  "
                  alt=""
                />
              </div>
              <div class="text">
                <div class="value" :style="`color: ${colorList[index]}`">
                  {{ item.value || 0 }}
                </div>
                <div class="label">{{ item.lable }}</div>
              </div>
            </div>
          </div>
        </el-col>
        <!-- <el-col :span="6">
          <div class="grid-item">
            <div class="value">{{ overviewData.outLineOverTimeNum || 0 }}</div>
            <div class="label">未上架超时SKU数（个）</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-item">
            <div class="value">{{ overviewData.outLineNum || 0 }}</div>
            <div class="label">未上架SKU数（个）</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-item">
            <div class="value">{{ overviewData.inLineNum || 0 }}</div>
            <div class="label">已上架SKU数（个）</div>
          </div>
        </el-col> -->
      </el-row>
    </div>
    <div
      style="margin: 0 10px 10px 10px"
      v-loading="loading3"
      element-loading-background="rgba(255,255,255,0.3)"
    >
      <div class="title-wrapper">
        <div>
          <span class="title" style="margin-right: 20px">节点平均耗时</span>
          <span
            class="tab-item"
            :class="{ active: tab2active === 1 }"
            @click="tab2Click(1)"
            >月度</span
          >
          <span
            class="tab-item"
            :class="{ active: tab2active === 2 }"
            @click="tab2Click(2)"
            >季度</span
          >
          <span
            class="tab-item"
            :class="{ active: tab2active === 3 }"
            @click="tab2Click(3)"
            >半年度</span
          >
        </div>
        <div>
          <div style="display: inline-block">
            <el-select
              v-model="totalYear"
              placeholder="请选择"
              class="yearSelect"
            >
              <el-option
                v-for="item in timeYear"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span class="text">年</span>
          </div>
          <div style="display: inline-block" v-if="this.tab2active == 1">
            <el-select
              v-model="totalMonth"
              placeholder="请选择"
              @change="monthChange"
              class="yearSelect"
              multiple
              collapse-tags
            >
              <el-option
                v-for="item in timeMonth"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span class="text">月</span>
          </div>
          <div style="display: inline-block" v-if="this.tab2active == 2">
            <el-select
              v-model="totalQuarter"
              placeholder="请选择"
              class="quarterSelect"
              @change="quarterChange"
              multiple
              collapse-tags
            >
              <el-option
                v-for="item in quarter"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span class="text">季度</span>
          </div>
          <div style="display: inline-block" v-if="this.tab2active == 3">
            <el-select v-model="jalfYear" class="yearSelect">
              <el-option label="上半年" value="1"></el-option>
              <el-option label="下半年" value="2"></el-option>
            </el-select>
            <span class="text">年度</span>
          </div>
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            class="buttonStyle"
            @click="monthSerch(tab2active)"
            >搜索</el-button
          >
        </div>
      </div>
      <!-- <el-row :gutter="10"> -->
      <!-- <el-col :span="6"> -->
      <div class="cavans" ref="node1"></div>
      <!-- </el-col>
        <el-col :span="6">
          <div class="cavans" ref="node2"></div>
        </el-col>
        <el-col :span="6">
          <div class="cavans" ref="node3"></div>
        </el-col>
        <el-col :span="6">
          <div class="cavans" ref="node4"></div>
        </el-col>
        <el-col :span="6">
          <div class="cavans" ref="node5"></div>
        </el-col>
        <el-col :span="6">
          <div class="cavans" ref="node6"></div>
        </el-col>
        <el-col :span="6">
          <div class="cavans" ref="node7"></div>
        </el-col>
        <el-col :span="6">
          <div class="cavans" ref="node8"></div> -->
      <!-- </el-col> -->
      <!-- </el-row> -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import tabLabel from "./tab-label";
// import './tab-label'
import chart1Mixin from "./chart1.mixin";
import chart2Mixin from "./chart2.mixin";
import chart3Mixin from "./chart3.mixin";
import chart4Mixin from "./chart4.mixin";
import chart5Mixin from "./chart5.mixin";
import chart6Mixin from "./chart6.mixin";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [
    chart1Mixin,
    chart2Mixin,
    chart3Mixin,
    chart4Mixin,
    chart5Mixin,
    chart6Mixin,
    pagePathMixin
  ],
  components: { tabLabel },
  data() {
    return {
      spuDateType: "1",
      startTime: moment(new Date()).subtract(3, "months").format("YYYY-MM-DD"),
      endTime: moment().format("YYYY-MM-DD"),
      tab0active: 2,
      tab1active: 1,
      tab2active: 1,
      category: [],
      categorys: [],
      overviewData: [],
      chartData1: {},
      chartData2: [],
      chartData3: [],
      chartData4: [],
      chartData5: [],
      chartData6: [],
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      pickerOptions: {
        cellClassName: (date) => this.pickerCellCls(date),
      },
      // 上新的日期
      newDates: [],
      totalYear: "",
      totalMonth: "",
      year: moment().year(),
      timeOne: "",
      totalQuarter: [],
      jalfYear: "",
      colorList: ["#D48747", "#D4CC47", "#7AD447", "#47D4D4"],
    };
  },
  computed: {
    timeYear() {
      let yearLength = this.year - 2021;
      let previousYear = this.year;
      let sumYear = [];
      for (let i = 0; i <= yearLength; i++) {
        sumYear.push({
          value: previousYear - i,
          lable: i,
        });
        sumYear.sort(function (a, b) {
          return b.lable - a.lable;
        });
      }
      return sumYear;
    },
    timeMonth() {
      let monthNum = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      let sumMonth = [];
      for (let i = 1; i <= monthNum.length; i++) {
        sumMonth.push({
          value: i,
          lable: i,
        });
      }
      return sumMonth;
    },
    quarter() {
      let quarterhNum = ["季度一", "季度二", "季度三", "季度四"];
      let sumQuarter = [];
      for (let i = 0; i < quarterhNum.length; i++) {
        sumQuarter.push({
          value: quarterhNum[i],
          lable: i,
        });
      }
      return sumQuarter;
    },
    // jalfYear() {
    //   let jalfYearhNum = [{value:"上半年",lable:"1"},{value:"下半年",lable:"2"}]
    //   let sumJalfYear= [];
    //   for (let i = 0; i < jalfYearhNum.length; i++) {
    //     sumJalfYear.push({
    //       value: jalfYearhNum[i].value,
    //       lable: jalfYearhNum[i].lable
    //     });
    //   }
    //   return sumJalfYear;
    // }
  },
  mounted() {
    this.init();
    this.getConfigByOptionType();
    this.get_queryNewProductPageDateFlag();
  },
  methods: {
    monthChange(e) {
      if (e.length > 3) {
        this.totalMonth.splice(-1);
      }
    },
    quarterChange(e) {
      if (e.length > 3) {
        this.totalQuarter.splice(-1);
      }
    },
    monthSerch(index) {
      if (this.tab2active == 1) {
        if (this.totalYear == "" || !this.totalMonth.length) {
          this.$message.error("请选择对应时间");
          return;
        }
      } else if (this.tab2active == 2) {
        if (this.totalYear == "" || !this.totalQuarter.length) {
          this.$message.error("请选择对应时间");
          return;
        }
      } else if (this.tab2active == 3) {
        if (this.totalYear == "" || this.jalfYear == "") {
          this.$message.error("请选择对应时间");
          return;
        }
      }
      let year = this.totalYear;
      let month = this.totalMonth;
      let time = [];
      month.forEach((v) => {
        let num = "";
        if (v > 9) {
          num = year + "-" + v;
          time.push(num);
          //  return year+v
        } else {
          num = year + "-0" + v;
          time.push(num);
          // return year+ '0'+v
        }
      });
      this.timeOne = time.sort();
      console.log(index);
      this.tab2Click(index);
    },
    // jalfYearSerch() {
    //   this.tab2Click(3);
    // },
    seach() {
      this.loading1 = true;
      let formData = {
        startTime: this.startTime,
        endTime: this.endTime,
        type: this.tab0active,
      };
      if (this.tab0active == 2) {
        formData["spuDateType"] = this.spuDateType;
      }
      this.$q.newProduct
        .newProductProductionOverview({ data: formData })
        .then((res) => {
          this.chartData1 = res.data;
          this.render_chart1(this.chartData1);
        })
        .finally((_) => {
          this.loading1 = false;
        });
    },
    tab0Click(index) {
      this.tab0active = index;
      this.$nextTick((_) => {
        this.get_queryNewProductPageDateFlag();
        this.seach();
      });
    },
    handleRadioChange() {
      this.get_queryNewProductPageDateFlag();
      this.seach();
    },
    tab1Click(index) {
      this.$refs["chart2"] && this.$echarts.dispose(this.$refs["chart2"]);
      this.$refs["chart6"] && this.$echarts.dispose(this.$refs["chart6"]);
      this.tab1active = index;
      this.$nextTick((_) => {
        index == 1 && this.render_chart2(this.chartData2);
        index == 2 && this.render_chart3(this.chartData3);
        index == 3 && this.render_chart6(this.chartData6);
      });
    },
    tab2Click(index) {
      this.loading3 = true;
      this.tab2active = index;
      let data = {};
      if (index == 1) {
        data = {
          type: this.tab2active,
          oneMouth: this.timeOne[0],
          towMouth: this.timeOne[1],
          threeMouth: this.timeOne[2],
        };
        this.totalQuarter = [];
        this.jalfYear = "";
      } else if (index == 2) {
        data = {
          type: this.tab2active,
          year: this.totalYear,
          quarter: this.totalQuarter,
        };
        this.jalfYear = "";
      } else {
        data = {
          type: this.tab2active,
          year: this.totalYear,
          jalfYear: parseInt(this.jalfYear) || "",
        };
        this.totalQuarter = [];
      }
      this.$q.newProduct
        .getSkuTaskAvgTime({ data: data })
        .then((res) => {
          this.chartData4 = res.data;
          // this.chartData4.forEach((item, index)=>{
          //   this.render_chart4(item, index+1)
          // })
          this.render_chart4(this.chartData4, this.tab2active);
        })
        .finally((_) => {
          this.loading3 = false;
        });
    },
    init() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const request1 = this.$q.newProduct.newProductProductionTotalData();
      const request2 = this.$q.newProduct.newProductProductionOverview({
        data: {
          type: this.tab0active,
          startTime: this.startTime,
          endTime: this.endTime,
          spuDateType: this.spuDateType,
        },
      });
      const request3 = this.$q.newProduct.getProgressInfo();
      const request4 = this.$q.newProduct.skuTaskSum({ data: this.category });
      // const request5 = this.$q.newProduct.getSkuTaskAvgTime({params: {type: this.tab2active}});
      const request5 = this.$q.newProduct.getSkuTaskAvgTime({
        data: { type: this.tab0active },
      });
      const request6 = this.$q.newProduct.getSpuMonthNum();
      const request7 = this.$q.newProduct.spuTaskNum();

      Promise.all([
        request1,
        request2,
        request3,
        request4,
        request5,
        request6,
        request7,
      ])
        .then((res) => {
          this.overviewData = [
            {
              value: res[0].data.averageTime,
              lable: "已上架平均耗时（天）",
            },
            {
              value: res[0].data.outLineOverTimeNum,
              lable: "未上架超时SKU数（个）",
            },
            {
              value: res[0].data.outLineNum,
              lable: "未上架SKU数（个）",
            },
            {
              value: res[0].data.inLineNum,
              lable: "已上架SKU数（个）",
            },
          ];

          this.chartData1 = res[1].data;

          this.chartData2 = res[2].data;

          this.chartData3 = res[3].data;

          // this.chartData4 = require('./mockData.json');
          this.chartData4 = res[4].data;

          this.chartData5 = res[5].data;

          this.chartData6 = res[6].data;

          this.render_chart1(this.chartData1);

          this.render_chart2(this.chartData2);

          // this.chartData4.forEach((item, index)=>{
          //   this.render_chart4(item, index+1)
          // })
          this.render_chart4(this.chartData4);
          this.render_chart5(this.chartData5);
        })
        .finally((_) => {
          loading.close();
        });
    },
    // 品类下拉
    getConfigByOptionType() {
      this.$q.newProduct.cateGoryList().then((res) => {
        if (res.code == 200) {
          this.categorys = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleCategoryChange(data) {
      this.loading2 = true;
      this.$q.newProduct
        .skuTaskSum({ data: this.category })
        .then((res) => {
          this.chartData3 = res.data;
          this.render_chart3(this.chartData3);
        })
        .finally((_) => {
          this.loading2 = false;
        });
    },
    // 日期选择器样式自定义
    pickerCellCls(date) {
      date = moment(date).format("YYYY-MM-DD");
      if (this.newDates.indexOf(date) > -1) {
        return "new";
      }
    },
    get_queryNewProductPageDateFlag() {
      let type;
      if (this.tab0active === 1) {
        type = 1;
      } else {
        if (this.spuDateType === "1") {
          type = 2;
        } else {
          type = 3;
        }
      }
      this.$q.newProduct
        .queryNewProductPageDateFlag({
          fragment: [type],
        })
        .then((res) => {
          this.newDates = res.data;
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.container {
  // margin: 5px;
  width: auto;
  min-height: 100%;
  box-sizing: border-box;
  background: #0B352B;
  border-radius: 5px;
  position: relative;
  z-index: 0;
  padding: 1px;

  &::before {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    content: '';
    background: url('../../../assets/images/lifeCycle_img/bg@2x.png') no-repeat center 0px;
    background-size: 100% 100%;
    z-index: -1;
  }
}

.title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: rgba(5, 72, 56, 0.6);
  margin-top: 10px;
}

.title {
  color: #FFFFFF;
  font-size: 16px;
  font-weight: bold;
  font-family: PingFangSC;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 25px;
    width: 46px;
    height: 5px;
    background: url('../../../assets/images/lifeCycle_img/header.png') no-repeat center 0px;
    background-size: 100% 100%;
  }
}

.label {
  color: #999;
  font-size: 14px;
}

.tab-item {
  color: #D8D8D8;
  font-size: 14px;
  cursor: pointer;
  font-family: PingFangSC;

  &.active {
    font-family: PingFangSC;
    color: #7BFFE0;
  }
}

.tab-item+.tab-item {
  margin-left: 15px;
}

.cavans {
  width: auto;
  height: calc(20vw - 6px);
  background: rgba(5, 72, 56, 0.6);
}

// >>>.el-row .el-col {
// margin-bottom: 10px;
// }
.grid-item {
  width: auto;
  height: 6vw;
  background: rgba(5, 72, 56, 0.6);
  color: rgb(11, 183, 142);
  text-align: center;
  font-family: PingFangSC;

  .value {
    text-align: left;
    font-size: 1.5vw;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .label {
    text-align: left;
    font-size: 14px;
    margin-bottom: 10px;
    color: rgba(255, 255, 255, 0.6);
  }
}

.haeaderColor {
  display: flex;
  height: 3px;
  width: 100%;
}

.content-time {
  height: 100%;
  display: flex;
  align-items: center;

  .img {
    flex: 0.3;
  }

  .text {
    flex: 0.7;
  }
}

.category-select {
  position: absolute;
  right: 10px;
  top: 5px;
}

>>> .el-input__inner {
  height: 28px;
  line-height: 28px;
  background-color: rgba(102, 255, 255, 0.1);
  border: 0;
  font-size: 12px;
  color: rgba(123, 255, 224, 0.6);
  font-family: PingFangSC;

  &::placeholder {
    color: rgba(123, 255, 224, 0.6);
    font-size: 12px;
  }
}

>>> .datePicker .el-date-editor .el-range-input {
  background: transparent;
  color: rgba(123, 255, 224, 0.6);
  font-size: 12px;
  font-family: PingFangSC;

  &::placeholder {
    color: rgba(123, 255, 224, 0.6);
    font-size: 12px;
  }
}

>>> .el-select .el-tag {
  background: rgba(102, 255, 255, 0.2);
  border: 0;
  color: rgba(123, 255, 224, 0.6);
}

>>> .el-radio {
  color: #D8D8D8;
  cursor: pointer;
  // font-family: PingFangSC;
}

.buttonStyle {
  background-color: transparent;
  color: rgba(46, 246, 217, 0.55);
  border: 1px solid rgba(46, 246, 217, 0.55);
  // width: 38px;
  padding: 6px 7px 6px 7px;
  font-family: PingFangSC;

  &:hover {
    background: #0BB78E;
    border-color: #0BB78E;
    color: #fff;
  }
}

>>> .yearSelect .el-input__inner {
  width: 130px;
  height: 28px;
}

>>> .quarterSelect .el-input__inner {
  width: 150px;
  height: 28px;
}

.lableFont {
  color: #ffffff;
  font-family: PingFangSC;
}

.text {
  color: #ffffff;
  display: inline-block;
  padding: 0px 10px;
  font-family: PingFangSC;
}
</style>